export default "__VITE_ASSET__G3IAlB9o__"